<div class="container">
  <div class="form-container">
    <h3>Forgot password</h3>

    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <form [formGroup]="form">

      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="email" placeholder="Email">
          <mat-icon>mail</mat-icon>
        </div>

        @if (form.controls.email.touched) {
          <div class="alert">

            @if (form.controls.email.hasError('email')) {
              <div class="form-validation-error">
                Incorrect email
              </div>
            }
          </div>
        }
      </div>

      <button matButton="filled" class="button-regular w-100 pb-12" [disabled]="form.invalid || isLoading" (click)="resetPassword()">Send Request</button>

      <div class="form-footer-block">
        <div class="form-hint">
          Enter your email address and we will send you a link to reset or create your password.
        </div>

      </div>

    </form>

  </div>

</div>
